import React, { createContext, useContext, useState, useEffect } from 'react';
import { lightTheme, darkTheme, type Theme } from '../styles/themes';

interface ThemeContextType {
  theme: Theme;
  isDark: boolean;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType>({
  theme: lightTheme,
  isDark: false,
  toggleTheme: () => {},
});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    try {
      const stored = localStorage.getItem('pp-theme');
      return stored === null ? false : stored === 'dark';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('pp-theme', isDark ? 'dark' : 'light');
    } catch { /* noop */ }
  }, [isDark]);

  return (
    <ThemeContext.Provider value={{
      theme: isDark ? darkTheme : lightTheme,
      isDark,
      toggleTheme: () => setIsDark(d => !d),
    }}>
      {children}
    </ThemeContext.Provider>
  );
};
